import React, { useState } from 'react';
import { useTheme } from "@emotion/react";
import { Button, IconButton, Popover, Box, Tooltip } from '@mui/material';
import { RxCross1 } from "react-icons/rx";

function ColorButton({buttonColor, handleSetColor}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const [coltrack, setColtrack] = useState("start")

  const colors = [
    { name: 'Red', value: '#db1d26' },
    { name: 'Green', value: '#5ce058' },
    { name: 'Blue', value: '#5ddcf5' },
    { name: 'Yellow', value: '#ffea47' },
    { name: 'Purple', value: '#ce58e0'  },
    { name: 'PrimaryLight', value: ''  },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'color-popover' : undefined;

  const handleColorChange = (colorValue) => {
    console.log(colorValue)
    handleSetColor(colorValue);
    setColtrack(colorValue);
    handleClose();
  };
  
  const colorOrCross = (color) => {
    if ( color.value) {
      return null;
    } else {
      return (<RxCross1 size={30}/>);
    }
  }
    

  return (
    <div>
      <Tooltip title="Highlight the section with different color" size="md" arrow>
        <Button
          aria-describedby={id}
          variant="contained"
          sx={{ 
            backgroundColor: buttonColor, 
            color: buttonColor ? '#fff' : 'rgba(0, 0, 0, 0.87)',
            minWidth: '30px', // Ensures the button is square-shaped
            height: '30px', // Height equal to the desired width to make it square
            borderRadius: '4px', // Rounded corners
          }}
          onClick={handleClick}
        >
        </Button>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            p: 1,
            m: 1,
            bgcolor: 'background.paper',
            borderRadius: 1,
            maxWidth: 130
          }}
        >
          {colors.map((color) => (
            <Box
              key={color.name}
              sx={{
                width: 30,
                height: 30,
                bgcolor: (color ? color.value : null),
                margin: 0.5,
                cursor: 'pointer',
                '&:hover': {
                  opacity: [0.9, 0.8, 0.7],
                }
              }}
              onClick={() => handleColorChange(color.value)}
            >
              {colorOrCross(color)}
            </Box>
          ))}
        </Box>
      </Popover>
    </div>
  );
}

export default ColorButton;
